import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const StepsSection = ({ 
  title, 
  subtitle,
  steps = [], 
  customClass = '',
  backgroundColor = 'bg-gray-50' 
}) => {
  return (
    <section className={`py-16 px-4 ${backgroundColor} ${customClass}`}>
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
          {parse(title)}
        </h2>
        <h2 className="text-2xl md:text-3xl font-normal text-white mb-24">
          {parse(subtitle)}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Step connector line for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-blue-200 z-0" 
                     style={{ transform: 'translateX(50%)' }} />
              )}
              
              <div className="h-[250px] relative z-10 bg-gray-50 rounded-lg p-6 shadow-md">
                <div className="flex flex-col items-center">
                  {/* Step number or icon */}
                  <div className="mt-[-70px] 4 w-24 h-24 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg mb-4">
                    {step.icon ? (
                      <img src={step.icon} alt="" className="w-24 h-24" />
                    ) : (
                      <span>{index + 1}</span>
                    )}
                  </div>
                  
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {parse(step.title)}
                  </h3>
                  
                  <p className="text-gray-600 text-center">
                    {parse(step.description)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

StepsSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string
  })).isRequired,
  customClass: PropTypes.string,
  backgroundColor: PropTypes.string
};

export default StepsSection;